// extracted by mini-css-extract-plugin
module.exports = {"sideBody":"SideBody_sideBody__2izFE"};